<h1><ng-content></ng-content></h1>
<div class="hr"></div>
